import type { FC } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";

import {
    StyledArrowContainer,
    StyledCardDescription,
    StyledCardMainContainer,
    StyledCardTitle,
    StyledCardTitleText,
    StyledIconContainer,
    StyledQuickActionCard,
    StyledQuickActionCardContent,
    StyledSWReactIcons,
} from "./styles";

interface QuickActionCardProps {
    title: string;
    description: string;
    iconName: IconName;
    onClick?: () => void;
    dataAutomation?: string;
    isNew?: boolean;
}

export const QuickActionCard: FC<QuickActionCardProps> = ({
    title,
    description,
    iconName,
    onClick,
    dataAutomation,
    isNew
}) => {
    return (
        <StyledQuickActionCard
            onClick={onClick}
            data-automation={dataAutomation}
        >
            <StyledQuickActionCardContent>
                <StyledIconContainer>
                    <StyledSWReactIcons
                        iconName={iconName}
                        size={"xs"}
                        iconColor={colorsPalettes.blue[400]}
                    />
                </StyledIconContainer>
                <StyledCardMainContainer>
                    <StyledCardTitle>
                        <StyledCardTitleText>{title}</StyledCardTitleText>
                        {isNew && <Badge type="new" />}
                    </StyledCardTitle>
                    <StyledCardDescription>{description}</StyledCardDescription>
                </StyledCardMainContainer>
            </StyledQuickActionCardContent>
            <StyledArrowContainer>
                <SWReactIcons
                    iconName={"arrow-right"}
                    iconColor={colorsPalettes.blue[400]}
                    size={"sm"}
                />
            </StyledArrowContainer>
        </StyledQuickActionCard>
    );
};
